module.exports = {"nav":{"links":[{"text":"Home","to":"/"},{"text":"About","to":"/about"},{"text":"Architecture","to":"/architecture"},{"text":"Interiors","to":"/interiors"},{"text":"Products","to":"/products"},{"text":"Blogs","to":"/blogs"}]}}


//////////////////
// WEBPACK FOOTER
// ./src/components/Nav/nav.json
// module id = 879
// module chunks = 114276838955818